import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { withRouter, RouteComponentProps } from 'react-router';
import { IState } from '@/state/IState';
import { InvitationWithToken } from '@/types';
import LoginForm from './LoginForm';
import { acceptInvite } from '@/services/user-invitations';
import { useSelector } from 'react-redux';
import { loadUser } from '@/state/global/creators';
import { Button as RubusButton } from '@ygtechnologies/rubus-ui';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';
import { useAppDispatch } from '@/utils/hooks';

type OwnProps = RouteComponentProps<any> & {
    invitation: InvitationWithToken;
};

const InvitationDetailsProject: React.FC<OwnProps> = ({ invitation, history, location }) => {
    const [acceptInProgress, setAcceptInProgress] = useState(false);
    const user = useSelector((state: IState) => state.global.user!);
    const dispatch = useAppDispatch();

    const redirectUrl = `/profiles/${invitation.inviteeProfileId}`;
    async function handleAccept(e) {
        e.preventDefault();

        setAcceptInProgress(true);

        try {
            await acceptInvite(invitation.token);
            loadUser(dispatch);
            history.replace(redirectUrl);
        } finally {
            setAcceptInProgress(false);
        }
    }

    if (!user.isLoggedIn) {
        return (
            <>
                <Trans>You are invited to collaborate on {invitation.invitedTo}.</Trans>

                <h3>
                    <Trans>Sign in to your Rubus account</Trans>
                </h3>

                <LoginForm initialEmail={invitation.inviteeEmail} />
            </>
        );
    }

    if (invitation.inviteeEmail.toLowerCase() !== user.email.toLowerCase()) {
        return (
            <div className="text-center flex column">
                <Trans>
                    You are currently logged in as {user.email} <br />
                    In order to accept this invitation you must be logged in as {invitation.inviteeEmail}.
                </Trans>

                <RubusButton
                    as={CustomLink}
                    to={`/logout?returnUrl=${encodeURIComponent(location.pathname + location.search)}`}
                    variant="primary"
                    size="lg"
                    loading={acceptInProgress}>
                    <Trans>Log out and switch user</Trans>
                </RubusButton>
            </div>
        );
    }

    return (
        <>
            <Trans>
                Click accept in order to accept the invitation to collaborate on {invitation.invitedTo} with {user.email}
            </Trans>

            <RubusButton variant="primary" block onClick={handleAccept} size="lg" loading={acceptInProgress}>
                <Trans>Accept invitation</Trans>
            </RubusButton>
        </>
    );
};

export default withRouter(InvitationDetailsProject);
